var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigitalClientLead(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.966,
    height: 16.194,
    viewBox: "0 0 19.966 16.194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        opacity: 0.1;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15480",
    "data-name": "Group 15480",
    transform: "translate(-99.418 -178.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7907",
    "data-name": "Group 7907",
    transform: "translate(99.425 178.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3189",
    "data-name": "Path 3189",
    d: "M2.5,17.368H1c-.552,0-1,.016-1-.5v-.291c0-.9-.131-.638.727-1.255l4.348-2.6c-1.914-1.737-1.832-4.955-1.839-5.1V4.855C3.615,2.66,5.95,1.224,8,1.224c.276,0,.451.079.451.34s-.175.329-.451.329c-1.8,0-3.744,1.467-4.007,2.962V7.611c0,.017-.089,3.614,2,4.875.152.091.357.234.347.4s-.132.193-.347.334L.881,16.274c-.1.048,0-.243,0,.3,0,0-.025.14,0,.133s1.619,0,1.619,0c.276,0,.45.089.45.349S2.776,17.368,2.5,17.368Z",
    transform: "translate(0 -1.001)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5241",
    "data-name": "Group 5241",
    transform: "translate(102.927 189.398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5239",
    "data-name": "Group 5239",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5236",
    "data-name": "Group 5236",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2045",
    "data-name": "Path 2045",
    d: "M268.993,399.562l-8.54.034c-.509,0-.953-.227-.953-.749v-.7a.406.406,0,0,1,.2-.352l5.68-3.246a.406.406,0,0,1,.4.7l-5.476,3.129v.847c0,.072-.059-.386,0-.386l8.681.012a.353.353,0,1,1,0,.7Z",
    transform: "translate(-259.5 -394.499)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5238",
    "data-name": "Group 5238",
    className: "cls-1",
    transform: "translate(13.996 3.183)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2047",
    "data-name": "Path 2047",
    className: "cls-2",
    d: "M311.244,406.266",
    transform: "translate(-311.244 -406.266)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15475",
    "data-name": "Group 15475",
    transform: "translate(6.573 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2045-2",
    "data-name": "Path 2045",
    d: "M259.891,399.562l8.54.034c.509,0,.953-.227.953-.749v-.7a.406.406,0,0,0-.2-.352l-5.68-3.246a.406.406,0,0,0-.4.7l5.476,3.129v.847c0,.072.059-.386,0-.386l-8.681.012a.353.353,0,1,0,0,.7Z",
    transform: "translate(-259.5 -394.499)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5242",
    "data-name": "Group 5242",
    transform: "translate(106.689 178.578)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2049",
    "data-name": "Path 2049",
    d: "M280.058,366.131a.406.406,0,0,1-.258-.719,5.738,5.738,0,0,0,1.725-4.307l0-3.075a3.808,3.808,0,0,0-3.622-2.718h-.028a3.811,3.811,0,0,0-3.65,2.719l0,3.053a5.9,5.9,0,0,0,1.769,4.328.406.406,0,0,1-.516.626,6.615,6.615,0,0,1-2.064-4.97l0-3.072a.42.42,0,0,1,.005-.067,4.593,4.593,0,0,1,4.425-3.428h.031c1.876,0,4.115,1.377,4.456,3.428a.425.425,0,0,1,.005.067l0,3.088a6.478,6.478,0,0,1-2.02,4.956A.4.4,0,0,1,280.058,366.131Z",
    transform: "translate(-273.408 -354.5)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_213",
    "data-name": "Ellipse 213",
    className: "cls-3",
    cx: 1.375,
    cy: 2.875,
    rx: 1.375,
    ry: 2.875,
    transform: "translate(106 181.078)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "AddClient",
    transform: "translate(114.756 167.448)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15474",
    "data-name": "Group 15474",
    transform: "translate(-9.986 14.014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5250",
    "data-name": "Group 5250",
    className: "cls-1",
    transform: "translate(2.485 2.491)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2053",
    "data-name": "Path 2053",
    className: "cls-2",
    d: "M200.977,406",
    transform: "translate(-200.977 -406)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5251",
    "data-name": "Group 5251",
    className: "cls-1",
    transform: "translate(2.491 2.491)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2054",
    "data-name": "Path 2054",
    className: "cls-2",
    d: "M201,406",
    transform: "translate(-201 -406)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5252",
    "data-name": "Group 5252",
    transform: "translate(2.098 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2055",
    "data-name": "Path 2055",
    d: "M199.893,401.482a.393.393,0,0,1-.393-.393v-4.2a.393.393,0,0,1,.787,0v4.2A.393.393,0,0,1,199.893,401.482Z",
    transform: "translate(-199.5 -396.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5253",
    "data-name": "Group 5253",
    transform: "translate(0 2.098)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2056",
    "data-name": "Path 2056",
    d: "M196.089,405.287h-4.2a.393.393,0,1,1,0-.787h4.2a.393.393,0,1,1,0,.787Z",
    transform: "translate(-191.5 -404.5)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalClientLead);
export default __webpack_public_path__ + "static/media/DigitalClientLead.0f623a7582e53e3dba57652aca266780.svg";
export { ForwardRef as ReactComponent };